import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faSquareFacebook, faLinkedin} from '@fortawesome/free-brands-svg-icons'

export default function Footer() {
  return (
    <>    
      <div className='footer-wrapper'>

        <div className="footer-left">
          <div className="footer-logo"></div>
          <div className="footer-info-box">
            <div className="footer-info-subtitle">
              Head Office
            </div>
            <div className="footer-info-body">
              40 Hallstrom Place, Wetherill Park, NSW, 2164
            </div>
          </div>
          <div className="footer-info-box">
            <div className="footer-info-subtitle">
              Contact
            </div>
            <div className="footer-info-body ">
              1300 042 360 | office@icombined360.com.au
            </div>
          </div>

          <div className="footer-info-box">
            <div className="footer-info-subtitle">
              About Company
            </div>
            <div className="footer-info-body">
              One Stop Shop combining service solutions
            </div>
          </div>        
          <div className="footer-info-box">
            <div className="footer-info-subtitle">
              Connect With Us
            </div>
            <a className="footer-info-body footer-ext-link" href="https://au.linkedin.com/company/icombined360" target='_blank' rel='noreferrer'>
            <FontAwesomeIcon icon={faLinkedin} />
            </a>
            <a className="footer-info-body footer-ext-link" href="https://www.facebook.com/icombined360/" target='_blank' rel='noreferrer'>
            &nbsp;<FontAwesomeIcon icon={faSquareFacebook} />
            </a>
          </div>
        </div>

        <div className="footer-right">
          <div className="footer-info-box">
            <div className="footer-info-subtitle ">
              Quick Links
            </div>
            <div className="footer-info-body footer-quick-box">
              <span className="footer-info-body-link">WHS</span>
              <div className="footer-info-body-link">Site</div>
              <div className="footer-info-body-link">Estimating</div>
              <div className="footer-info-body-link">Labour</div>
              <div className="footer-info-body-link">Traffic</div>
              <div className="footer-info-body-link">Human Resources</div>
              <div className="footer-info-body-link">Engineering</div>
              <div className="footer-info-body-link">Software</div>
              <div className="footer-info-body-link">Misc</div>
            </div>
          </div>

          <div className='footer-copyright'>
          © 2023 - IC360 Portal
        </div>
        </div>

      </div>
      
    </>

  )
}
